import { render, staticRenderFns } from "./AgvTabs.vue?vue&type=template&id=38627bb6&scoped=true&"
import script from "./AgvTabs.vue?vue&type=script&lang=js&"
export * from "./AgvTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38627bb6",
  null
  
)

export default component.exports